import {
  Box,
  Button,
  Grid,
  TextField,
  Modal,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useState } from "react";
import "./Fpm.css";
import img1 from "../images/fmpAssets/flipCardsImg/banks_front.png";
import img2 from "../images/fmpAssets/flipCardsImg/cooperatives_front.png";
import img3 from "../images/fmpAssets/flipCardsImg/microfinance-non-governmental-organizations_front.png";
import img4 from "../images/fmpAssets/flipCardsImg/lending-and-finance-companies_front.png";
import img5 from "../images/fmpAssets/flipCardsImg/insurance-companies.png";
import img6 from "../images/fmpAssets/flipCardsImg/digital-financial-service-providers_front.png";
import img7 from "../images/fmpAssets/flipCardsImg/mutual-benefit-associations.png";
import { useDispatch } from "react-redux";
import { setFpmQuestion1 } from "../features/fpmSlice/FmpSlice";
import { useNavigate } from "react-router-dom";
import { CloseRounded } from "@mui/icons-material";
import Logo from "../images/logo_quick-learning-tool.png";
import Swal from "sweetalert2";

function FpmPageFil() {
  const [question1, setQuestion1] = useState();
  const [modalText, setModalText] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openFSP, setOpenFSP] = useState(false);
  const handleCloseFSP = () => setOpenFSP(false);

  const handleOpenFSP = (type) => {
    setOpenFSP(true);

    if (type === "Bank") {
      setModalText(
        "Ang mga bangko ay pinangangalagaan ng Bangko Sentral ng Pilipinas (BSP) at awtorisado na magbigay ng mga produktong tulad ng savings/deposits, loan products, insurance, investments, at remittances, kasama ang iba pa, sa publiko."
      );
    } else if (type === "Coop") {
      setModalText(
        "Ang mga kooperatiba ay pinangangalagaan ng Cooperative Development Authority (CDA) at awtorisado na magbigay lamang ng mga produkto sa savings at loan products sa kanilang mga miyembro."
      );
    } else if (type === "Micro") {
      setModalText(
        "Ang mga Microfinance NGOs ay pinangangalagaan ng Microfinance NGO Regulatory Council (MNRC) na pinamumunuan ng Securities and Exchange Commission (SEC) at awtorisado na magbigay ng mga pautang, na sinasamahan ng pagpapamobilisa ng ipon o pagtatayo ng kapital na hindi lalampas sa 50% ng halaga ng pautang, na may mga taong may mababang kita bilang target na mga kostumer."
      );
    } else if (type === "Lend") {
      setModalText(
        "Ang mga Lending at Finance Companies ay pinangangalagaan ng Securities and Exchange Commission (SEC) na may pangunahing aktibidad na magpahiram ng pera sa publiko. Bilang mga korporasyong may stock, dapat itong magpahiram mula sa sariling pondo o mula sa pondo na nakukuha mula sa hindi hihigit sa 19 na tao."
      );
    } else if (type === "Insur") {
      setModalText(
        "Ang mga Insurance Companies ay nag-aalok ng mga produktong seguro mula sa pagbabayad ng mga premium, na pinangangasiwaan ng Insurance Commission."
      );
    } else if (type === "Mutual") {
      setModalText(
        "Ang mga Mutual Benefit Associations ay nagbibigay ng insurance at iba pang mga benepisyo sa kanilang mga miyembro sa pamamagitan ng pagbabayad membership fee, na pinangangasiwaan ng Insurance Commission."
      );
    } else if (type === "DSP") {
      setModalText(
        "Ang mga Digital FSPs ay naiiba sa iba pang mga FSPs sa pamamagitan ng kanilang pangunahing paggamit ng mga teknolohiyang pinansyal upang magbigay ng kanilang mga produkto at serbisyo. Ang mga digital platforms na kanilang ginagamit ay nag-aalok ng online access sa  savings, loans, at insurance. Sa pamamagitan ng kombinasyon ng teknolohiya, malalaking datos, at mga pribadong modelo ng desisyon, may kakayahan itong magbigay ng iba't ibang mga opsyon sa mga kostumer na pinakamainam para sa kanilang pamumuhay."
      );
    }
  };

  const handleContinue = () => {
    if (question1) {
      handleOpen();
    } else {
      Swal.fire({
        icon: "error",
        title: "Hindi kumpletong patlang",
        text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
    }
  };

  const handleNext = () => {
    dispatch(setFpmQuestion1(question1));
    navigate("/page2/Fil");
  };

  return (
    <Box className="Main__Card__FPM">
      <Grid container>
        <Grid Item xs={12} md={3} className="left-card">
          <Box className="new-logo-container">
            <img src={Logo} alt="logo" className="new-logo-img" />
          </Box>
          <Box sx={{ marginBottom: "1rem" }}>
            <Button className="fpm--button" onClick={() => navigate("/")}>
              To English Ver.
            </Button>
          </Box>
          <Box className="instruction-card">
            <p className="instruction-title">Gabay</p>
            <p className="instruction-text">
              Pumili ng Angkop na Produkto at Tagapagbigay ng Serbisyong
              Pinansyal.
            </p>
            <p className="instruction-text">
              Ang isang customer na may kakayahan ay alam kung aling mga feature
              ng produkto ang akma sa kanyang mga pangangailangan at kondisyon
              at kayang magkumpara ng mga feature ng produkto sa pagitan ng 2-4
              Financial Service Providers (FSPs) na aktibo sa lugar.
            </p>
            <p className="instruction-text">
              Sa bahaging ito, ibinibigay ang mga ehersisyo upang muling
              pabanguhin ang customer tungkol sa iba't ibang uri ng FSPs at ang
              mga feature ng produkto na dapat isaalang-alang sa bawat napiling
              produktong pinansyal. Isang tool na tinatawag na Financial Product
              Matrix (FPM) ay magagamit upang tulungan na organisahin ang
              impormasyon ng produkto na magpapadali sa paghahambing at
              pagraranggo sa pagitan ng FSPs batay sa partikular na mga
              kagustuhan ng customer.
            </p>
          </Box>
        </Grid>
        <Grid Item xs={12} md={9} className="right-card">
          <Box className="fpm__card">
            <Box className="fpm__container">
              <Box className="fpm--opening--text1">
                <p>Kilalanin ang Financial Service Providers (FSP)</p>
              </Box>
              <Grid container>
                <Grid item xs={12} md={6} className="child-left-card">
                  <Box sx={{ marginBottom: "1rem" }}>
                    <h4>Mga Uri ng FSP</h4>
                    <p>
                      I-click ang kahon upang basahin ang karagdagang
                      impormasyon.
                    </p>
                  </Box>
                  <Box className="card-container">
                    <Box className="flip-card-containers">
                      <img
                        src={img1}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Bank")}
                      />
                    </Box>
                    <Box className="flip-card-containers">
                      <img
                        src={img2}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Coop")}
                      />
                    </Box>
                    <Box className="flip-card-containers">
                      <img
                        src={img3}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Micro")}
                      />
                    </Box>
                  </Box>
                  <Box className="card-container" sx={{ marginTop: "1rem" }}>
                    <Box className="flip-card-containers">
                      <img
                        src={img4}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Lend")}
                      />
                    </Box>
                    <Box className="flip-card-containers">
                      <img
                        src={img5}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Insur")}
                      />
                    </Box>
                    <Box className="flip-card-containers">
                      <img
                        src={img7}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Mutual")}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      marginTop: "1rem",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box sx={{ width: "30%" }}>
                      <img
                        src={img6}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("DSP")}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} className="child-right-card">
                  <Box className="fpm--question--text">
                    <p>
                      Batay sa iyong layunin at planong pampinansyal, aling uri
                      ng FSP sa palagay mo ang maaaring magbigay sa iyo ng
                      kinakailangang produktong pinansyal?
                    </p>
                  </Box>

                  <Box className="fpm--radio--group--container">
                    <FormControl>
                      <RadioGroup className="fpm--radio--group">
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Banks"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Banks"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Cooperatives"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Cooperatives"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Insurance Companies"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Insurance Companies"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Lending & Finance Companies"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Lending & Finance Companies"
                        />

                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Mutual Benefit Associations"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Mutual Benefit Associations"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Digital Financial Service Providers"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Digital Financial Service Providers"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Microfinance Non-Governmental Organizations"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Microfinance Non-Governmental Organizations"
                        />
                      </RadioGroup>
                    </FormControl>
                    <Box className="fpm__button__container">
                      <Button
                        className="fpm--button"
                        onClick={() => handleContinue()}
                      >
                        Sunod
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Modal open={open} onClose={handleClose}>
        <Box className="fpm__modal">
          <Box className="fpm--ending--text">
            <p
              style={{
                fontSize: "1.7rem",
                fontWeight: "700",
                marginBottom: "2rem",
              }}
            >
              Sandali lamang!
            </p>
            <p>
              Huwag magdesisyon agad.
              <br />
              <br />
              Ang isang kostumer na may kakayahan ay mag-iipon muna ng
              impormasyon, karaniwang mula sa higit pa sa isang FSP,
              magkukumpara kung aling FSP ang nag-aalok ng pinakaangkop na
              produkto, at saka magdedesisyon nang may sapat na kaalaman.
              <br />
              <br />
              Pindutin lamang ang Sunod na button para magpatuloy.
            </p>

            <Button className="fpm--button--modal" onClick={() => handleNext()}>
              Sunod
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={openFSP} onClose={handleCloseFSP}>
        <Box className="fpm__modal">
          <Box className="fpm--modal--text">
            <CloseRounded
              className="fpm--modal--iconButton"
              onClick={handleCloseFSP}
            />
            <p>{modalText}</p>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default FpmPageFil;
